import React from 'react';
import { motion } from 'framer-motion';
import { YoutubeIcon, UsersIcon, FileTextIcon, XIcon } from 'lucide-react';
export function WhyFailsSection() {
  return <section className="bg-zinc-950 py-16 sm:py-24" data-id="element-323">
      <div className="max-w-4xl mx-auto px-4" data-id="element-324">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-325">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-4" data-id="element-326">
            <span className="text-red-500" data-id="element-327">¿Por qué</span> los métodos actuales
            fallan?
          </h2>
          <p className="text-zinc-400 text-lg" data-id="element-328">
            "Pero ya intenté con tutoriales de internet..."
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-329">
          {/* YouTube */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 sm:p-8" data-id="element-330">
            <div className="flex items-start gap-4" data-id="element-331">
              <div className="w-12 h-12 bg-red-500/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-332">
                <YoutubeIcon className="w-6 h-6 text-red-500" data-id="element-333" />
              </div>
              <div className="flex-1" data-id="element-334">
                <div className="flex items-center gap-2 mb-2" data-id="element-335">
                  <h3 className="text-white font-bold text-lg" data-id="element-336">
                    Videos de YouTube
                  </h3>
                  <XIcon className="w-5 h-5 text-red-500" data-id="element-337" />
                </div>
                <p className="text-zinc-400" data-id="element-338">
                  La mayoría tienen 1 o 2 años. Las versiones del APK cambian.
                  Los links mueren. La interfaz de tu tele es diferente a la del
                  video. Y el creador no responde comentarios.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Forums */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 sm:p-8" data-id="element-339">
            <div className="flex items-start gap-4" data-id="element-340">
              <div className="w-12 h-12 bg-blue-500/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-341">
                <UsersIcon className="w-6 h-6 text-blue-500" data-id="element-342" />
              </div>
              <div className="flex-1" data-id="element-343">
                <div className="flex items-center gap-2 mb-2" data-id="element-344">
                  <h3 className="text-white font-bold text-lg" data-id="element-345">
                    Foros y grupos de Facebook
                  </h3>
                  <XIcon className="w-5 h-5 text-red-500" data-id="element-346" />
                </div>
                <p className="text-zinc-400" data-id="element-347">
                  Información contradictoria. Alguien dice una cosa, otro dice
                  lo contrario. Los links están caídos. Y cuando preguntas algo,
                  nadie responde o te mandan a otro grupo.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Blogs */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 sm:p-8" data-id="element-348">
            <div className="flex items-start gap-4" data-id="element-349">
              <div className="w-12 h-12 bg-purple-500/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-350">
                <FileTextIcon className="w-6 h-6 text-purple-500" data-id="element-351" />
              </div>
              <div className="flex-1" data-id="element-352">
                <div className="flex items-center gap-2 mb-2" data-id="element-353">
                  <h3 className="text-white font-bold text-lg" data-id="element-354">
                    Blogs genéricos
                  </h3>
                  <XIcon className="w-5 h-5 text-red-500" data-id="element-355" />
                </div>
                <p className="text-zinc-400" data-id="element-356">
                  Copiados unos de otros. Sin capturas actualizadas. Sin
                  mencionar los errores comunes que sí o sí vas a encontrar.
                  Escritos para posicionarse en Google, no para ayudarte de
                  verdad.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Conclusion */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-10 text-center" data-id="element-357">
          <p className="text-xl sm:text-2xl text-white font-bold" data-id="element-358">
            La falla no está en la aplicación.{' '}
            <span className="text-emerald-400" data-id="element-359">Está en la guía.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}